(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const body = drawer.querySelector('[data-cart-drawer-body]');
    const footer = drawer.querySelector('[data-cart-drawer-footer]');
    const estimatedTotal = drawer.querySelector('[data-cart-drawer-total]');
    const checkout = drawer.querySelector('[data-cart-checkout]');
    const footerRecommendation = drawer.querySelector('[data-cart-drawer-recommendation]');
    const savingsRow = drawer.querySelector('[data-cart-drawer-savings]');
    const savingsValue = drawer.querySelector('[data-cart-drawer-savings-value]');
    const savingsLabel = drawer.querySelector('[data-cart-drawer-savings-label]');
    const discountCodes = drawer.querySelector('[data-cart-discount-codes]');
    const status = drawer.querySelector('[data-cart-status]');
    const panel = drawer.querySelector('.cart-drawer__panel');
    const drawerCount = drawer.querySelector('[data-cart-drawer-count]');
    const recommendationsSource = drawer.querySelector('[data-cart-recommendations]');
    const root = window.Shopify?.routes?.root || '/';
    let recommendations = [];
    let previousFocus = null;
    let lineChangeController = null;
    let addPending = false;

    try {
      recommendations = JSON.parse(recommendationsSource?.textContent || '[]').filter(Boolean);
    } catch (error) {
      recommendations = [];
    }

    const money = (cents) => {
      const currency = drawer.dataset.currency;
      const locale = document.documentElement.lang || navigator.language;

      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((cents || 0) / 100);
      } catch (error) {
        return `${((cents || 0) / 100).toFixed(2)}${currency ? ` ${currency}` : ''}`;
      }
    };

    const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[character]);

    const setStatus = (message = '') => {
      if (!status) return;
      status.textContent = message;
    };

    const setLoading = (isLoading) => {
      drawer.classList.toggle('is-loading', isLoading);
      if (isLoading) setStatus(drawer.dataset.loadingText || 'Loading cart.');
    };

    const cartIcon = '<svg class="cart-drawer__button-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>';
    const lockIcon = '<svg class="cart-drawer__checkout-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
    const saveIcon = `<img class="save-tag-icon" src="${escapeHtml(drawer.dataset.tagIconUrl || '')}" alt="" width="14" height="14">`;
    const emptyButtonLabel = drawer.dataset.emptyButton || 'Shop Now';
    const checkoutLabel = drawer.dataset.checkoutLabel || 'Continue To Checkout';

    const updateHeaderCount = (count) => {
      if (drawerCount) drawerCount.textContent = `(${count})`;

      document.querySelectorAll('[data-cart-toggle]').forEach((toggle) => {
        let badge = toggle.querySelector('.site-header__cart-count');

        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-count';
            toggle.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      });
    };

    const isSameProduct = (item, product) => {
      if (!item || !product) return false;
      return Number(item.product_id) === Number(product.productId) || Number(item.variant_id) === Number(product.variantId) || item.product_title === product.productTitle;
    };

    const lineOptions = (item) => {
      if (!item.options_with_values || item.options_with_values.length === 0) return '';

      return item.options_with_values
        .filter((option) => option.value && option.value !== 'Default Title')
        .map((option) => `<p class="cart-drawer__variant">${escapeHtml(option.value)}</p>`)
        .join('');
    };

    let recommendationCurrency = drawer.dataset.currency;
    const referenceLineTotal = (item) => {
      const matchingProduct = recommendations.find((product) => Number(product.variantId) === Number(item.variant_id));
      const quantity = Number(item.quantity || 0);
      const originalTotal = Number(item.original_line_price || 0);
      const sameCurrency = drawer.dataset.currency === recommendationCurrency;
      const reference = matchingProduct && sameCurrency && !item.selling_plan_allocation
        ? Number(matchingProduct.comparePrice || 0)
        : 0;
      return Math.max(originalTotal, reference * quantity);
    };

    const discountApplication = (allocation) => allocation?.discount_application || allocation?.discountApplication || {};

    const acceptedDiscountCodes = (cart) => {
      const accepted = new Map();
      (cart.discount_codes || []).forEach((entry) => {
        if (entry?.applicable !== true || !entry.code) return;
        accepted.set(String(entry.code).toLowerCase(), { code: String(entry.code) });
      });
      const captureApplication = (application) => {
        const type = String(application?.type || application?.target_type || '').toLowerCase();
        const code = String(application?.code || application?.title || '').trim();
        if (!code || (type && !type.includes('discount_code'))) return;
        accepted.set(code.toLowerCase(), { code });
      };
      (cart.items || []).forEach((item) => {
        const allocations = item.discount_allocations || item.line_level_discount_allocations || [];
        allocations.forEach((allocation) => captureApplication(discountApplication(allocation)));
      });
      (cart.cart_level_discount_applications || []).forEach(captureApplication);
      return Array.from(accepted.values());
    };

    const codeSavingsByTitle = (cart) => {
      const savings = new Map();
      cart.items.forEach((item) => {
        const allocations = item.discount_allocations || item.line_level_discount_allocations || [];
        allocations.forEach((allocation) => {
          const application = discountApplication(allocation);
          const type = String(application.type || application.target_type || '').toLowerCase();
          const title = String(application.title || application.code || '').trim();
          if (!title || (type && !type.includes('discount_code'))) return;
          savings.set(title.toLowerCase(), (savings.get(title.toLowerCase()) || 0) + Number(allocation.amount || 0));
        });
      });
      (cart.cart_level_discount_applications || []).forEach((application) => {
        const type = String(application.type || application.target_type || '').toLowerCase();
        const title = String(application.title || application.code || '').trim();
        if (!title || (type && !type.includes('discount_code'))) return;
        const amount = Number(application.total_allocated_amount || 0);
        savings.set(title.toLowerCase(), Math.max(savings.get(title.toLowerCase()) || 0, amount));
      });
      return savings;
    };

    const pricingSummary = (cart) => {
      const referenceTotal = cart.items.reduce((total, item) => total + referenceLineTotal(item), 0);
      const sellingSubtotal = cart.items.reduce((total, item) => total + Number(item.original_line_price || 0), 0);
      const finalSubtotal = Number(cart.total_price ?? 0);
      const shopifyDiscountSavings = Math.max(0, Number(cart.total_discount || 0));
      const productSavings = Math.max(0, referenceTotal - sellingSubtotal);
      const codeMap = codeSavingsByTitle(cart);
      const codes = acceptedDiscountCodes(cart).map((entry) => ({
        code: entry.code,
        amount: Math.max(0, Number(codeMap.get(String(entry.code).toLowerCase()) || 0))
      }));
      const codeSavings = Math.min(shopifyDiscountSavings, codes.reduce((total, entry) => total + entry.amount, 0));
      const otherDiscountSavings = Math.max(0, shopifyDiscountSavings - codeSavings);
      const totalEffectiveSavings = Math.max(0, referenceTotal - finalSubtotal);
      return { referenceTotal, sellingSubtotal, finalSubtotal, productSavings, codeSavings, otherDiscountSavings, totalEffectiveSavings, codes };
    };

    const renderDiscountPricing = (cart) => {
      const summary = pricingSummary(cart);
      const hasNonCodeSavings = summary.productSavings > 0 || summary.otherDiscountSavings > 0;
      if (discountCodes) {
        discountCodes.hidden = summary.codes.length === 0;
        discountCodes.innerHTML = summary.codes.map((entry) => `
          <span class="cart-drawer__discount-code">
            ${saveIcon}
            <strong>${escapeHtml(entry.code)}</strong>
            ${entry.amount > 0 ? `<small>−${money(entry.amount)}</small>` : ''}
          </span>
        `).join('');
      }
      if (savingsRow) savingsRow.hidden = !hasNonCodeSavings;
      const referenceValue = drawer.querySelector('[data-cart-drawer-reference]');
      if (referenceValue) {
        referenceValue.hidden = !hasNonCodeSavings;
        referenceValue.textContent = hasNonCodeSavings ? money(summary.referenceTotal) : '';
      }
      if (savingsLabel) {
        const effectivePercent = hasNonCodeSavings && summary.referenceTotal > 0
          ? Math.round((summary.totalEffectiveSavings / summary.referenceTotal) * 100)
          : 0;
        savingsLabel.innerHTML = effectivePercent > 0 ? `${saveIcon}<span style="color:#fff !important;-webkit-text-fill-color:#fff !important">${effectivePercent}% Off</span>` : '';
        savingsLabel.style.setProperty('color', '#fff', 'important');
        if (savingsRow) savingsRow.hidden = effectivePercent <= 0;
      }
      return summary;
    };

    const linePrice = (item) => {
      const finalPrice = Number(item.final_line_price || 0);
      const comparePrice = referenceLineTotal(item);
      const compare = comparePrice > finalPrice ? `<s>${money(comparePrice)}</s>` : '';
      return `<span class="cart-drawer__line-price"><span class="cart-drawer__line-price-row"><strong>${money(finalPrice)}</strong>${compare}</span></span>`;
    };

    const responsiveAssetUrl = (url, width) => {
      if (!url) return '';
      return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
    };

    const renderLine = (item) => {
      const matchingProduct = recommendations.find((product) => isSameProduct(item, product));
      const imageUrl = matchingProduct?.image || item.image;
      const image = imageUrl
        ? `<img src="${escapeHtml(responsiveAssetUrl(imageUrl, 144))}" srcset="${escapeHtml(responsiveAssetUrl(imageUrl, 72))} 72w, ${escapeHtml(responsiveAssetUrl(imageUrl, 144))} 144w, ${escapeHtml(responsiveAssetUrl(imageUrl, 216))} 216w" sizes="72px" alt="${escapeHtml(item.product_title)}" width="72" height="72" loading="lazy" decoding="async">`
        : `<span class="cart-drawer__image-placeholder" aria-hidden="true">${escapeHtml((typeof product !== 'undefined' ? product.title : item.product_title).split(' ').map((word) => word[0]).join('').slice(0, 3))}</span>`;
      const roleClass = matchingProduct?.role ? ` cart-drawer__line--${escapeHtml(matchingProduct.role)}` : '';

      return `
        <article class="cart-drawer__line${roleClass}" data-cart-line="${escapeHtml(item.key)}">
          <a class="cart-drawer__media" href="${escapeHtml(item.url)}">${image}</a>
          <div class="cart-drawer__line-copy">
            <a class="cart-drawer__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${lineOptions(item)}
          </div>
          <div class="cart-drawer__controls">
            <div class="cart-drawer__quantity" aria-label="${escapeHtml(drawer.dataset.quantityLabel)}">
              <button type="button" data-cart-line-step="-1" aria-label="${escapeHtml(drawer.dataset.decreaseLabel)}">−</button>
              <input type="number" min="0" value="${item.quantity}" inputmode="numeric" aria-label="${escapeHtml(drawer.dataset.quantityLabel)}">
              <button type="button" data-cart-line-step="1" aria-label="${escapeHtml(drawer.dataset.increaseLabel)}">+</button>
            </div>
            <button class="cart-drawer__remove" type="button" data-cart-line-remove aria-label="${escapeHtml(drawer.dataset.removeLabel)}">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M3 6h18"/>
                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6"/>
                <path d="M14 11v6"/>
              </svg>
              <span class="visually-hidden">${escapeHtml(drawer.dataset.removeLabel)}</span>
            </button>
          </div>
          ${linePrice(item)}
        </article>
      `;
    };

    const renderProductCard = (product, options = {}) => {
      if (!product) return '';

      const image = product.image
        ? `<img src="${escapeHtml(responsiveAssetUrl(product.image, 132))}" srcset="${escapeHtml(responsiveAssetUrl(product.image, 66))} 66w, ${escapeHtml(responsiveAssetUrl(product.image, 132))} 132w, ${escapeHtml(responsiveAssetUrl(product.image, 198))} 198w" sizes="76px" alt="${escapeHtml(product.title)}" width="76" height="76" loading="lazy" decoding="async">`
        : `<span class="cart-drawer__image-placeholder" aria-hidden="true">${escapeHtml((typeof product !== 'undefined' ? product.title : item.product_title).split(' ').map((word) => word[0]).join('').slice(0, 3))}</span>`;

      const save = product.saveLabel
        ? `<em>${saveIcon}${escapeHtml(product.saveLabel)}</em>`
        : '';
      const cardLabel = options.label ?? product.label;
      const label = options.quiet ? '' : product.timedOffer
        ? (drawer.querySelector('[data-clay-offer-template]')?.innerHTML || '')
        : cardLabel ? `<small class="cart-drawer__product-badge">${escapeHtml(cardLabel)}</small>` : '';
      const comparePrice = product.comparePrice && product.comparePrice > product.price
        ? `<s>${money(product.comparePrice)}</s>`
        : '';
      const priceDetails = options.showPriceDetails
        ? `<span class="cart-drawer__product-price-row"><strong>${money(product.price)}</strong>${comparePrice}</span>` : '';
      const meta = save && !options.quiet ? `<p class="cart-drawer__product-value">${save}</p>` : '';
      const note = options.contents?.length ? `<button class="cart-drawer__contents-toggle" type="button" data-cart-contents-toggle aria-expanded="false">${escapeHtml(upgradeCopy.included || "What's Included?")}</button>` : '';
      const contentsPanel = options.contents?.length ? `<ul class="cart-drawer__contents-list fresh-bundle-contents__list" role="list" hidden>${options.contents.map((entry) => `<li><span class="fresh-bundle-contents__thumb">${entry.image ? `<img src="${escapeHtml(responsiveAssetUrl(entry.image, 112))}" alt="" width="48" height="48" loading="lazy" decoding="async">` : ''}</span><span class="fresh-bundle-contents__text">${escapeHtml(entry.text)}</span></li>`).join('')}</ul>` : '';
      const buttonLabel = options.buttonLabel || drawer.dataset.addLabel || 'Add To Cart';
      const actionAttributes = options.upgradeLines?.length
        ? `data-cart-bundle-upgrade="${product.variantId}" data-cart-upgrade-lines="${escapeHtml(options.upgradeLines.join('|'))}"`
        : `data-cart-recommendation-add="${product.variantId}"`;
      const buttonPrice = options.hideButtonPrice ? '' : `<span>${money(product.price)}</span>`;
      const action = product.available && product.variantId
        ? `<button class="cart-drawer__product-add" type="button" ${actionAttributes}>${cartIcon}${escapeHtml(buttonLabel)}${buttonPrice}</button>`
        : `<span class="cart-drawer__sold-out">${escapeHtml(drawer.dataset.soldOutLabel || 'Sold out')}</span>`;

      return `
        <article class="cart-drawer__product-card${product.role ? ` cart-drawer__product-card--${escapeHtml(product.role)}` : ''}${options.featured ? ' cart-drawer__product-card--featured' : ''}${options.compact ? ' cart-drawer__product-card--compact' : ''}${options.quiet ? ' cart-drawer__product-card--quiet' : ''}${cardLabel || product.timedOffer ? ' cart-drawer__product-card--has-badge' : ''}">
          ${label}
          <a class="cart-drawer__product-media" href="${escapeHtml(product.url)}">${image}</a>
          <div class="cart-drawer__product-copy">
            <a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
            ${priceDetails}
            ${note}
          </div>
          ${meta}
          ${action}
          ${contentsPanel}
        </article>
      `;
    };

    const componentRoles = {
      single: ['single'], bundle: ['single', 'single'], shampoo: ['shampoo'], conditioner: ['conditioner'],
      'hair-clay': ['hair-clay'], 'hair-clay-2-pack': ['hair-clay', 'hair-clay'], washday: ['shampoo', 'conditioner'],
      'complete-routine': ['shampoo', 'conditioner', 'single'],
      'texture-styling-duo': ['single', 'hair-clay'],
      'wash-clay-trio': ['shampoo', 'conditioner', 'hair-clay'],
      'complete-hair-system': ['shampoo', 'conditioner', 'single', 'hair-clay']
    };
    const roleHandles = {single: 'texture-powder', bundle: 'texture-powder-2-pack', washday: 'wash-day-bundle', 'complete-routine': 'complete-hair-routine'};
    const salesOrder = (drawer.dataset.salesOrder || '').split(',').filter(Boolean);
    const salesRank = (product) => {
      const index = salesOrder.indexOf(roleHandles[product.role] || product.role);
      return index < 0 ? Number.MAX_SAFE_INTEGER : index;
    };
    const rankedRecommendations = () => [...recommendations].sort((a, b) => salesRank(a) - salesRank(b) || a.title.localeCompare(b.title));
    const emptyRecommendations = () => {
      const eligible = rankedRecommendations().filter((product) => product.available && product.variantId);
      const launch = drawer.dataset.launchEnabled !== 'false'
        ? eligible.find((product) => (roleHandles[product.role] || product.role) === drawer.dataset.launchHandle)
        : null;
      const ordered = launch ? [launch, ...eligible.filter((product) => product !== launch)] : eligible;
      const covered = new Set();
      return ordered.filter((product) => {
        const parts = componentRoles[product.role] || [];
        if (!parts.length || parts.some((part) => covered.has(part))) return false;
        parts.forEach((part) => covered.add(part));
        return true;
      }).slice(0, 3);
    };
    const productForLine = (line) => recommendations.find((product) => isSameProduct(line, product));
    const cartComponents = (cart) => cart.items.flatMap((line) => componentRoles[productForLine(line)?.role] || []);
    const upgradePlans = (cart) => {
      // Prefer a saving on the same contents, then a small, relevant addition.
      // A bundle that adds a different product comes before a 2 Pack of the same one (Lucas, 11 Oct 2026).
      // Recent offer performance breaks ties between equally relevant upgrades.
      const priorities = rankedRecommendations().filter((product) => componentRoles[product.role]?.length > 1).map((product) => product.role);
      const plans = [];
      const eligible = cart.items.filter((line) => Number.isInteger(Number(line.quantity)) && Number(line.quantity) > 0
        && !line.selling_plan_allocation && !Object.keys(line.properties || {}).length
        && componentRoles[productForLine(line)?.role] && Number.isFinite(Number(line.final_line_price)))
        .sort((a, b) => componentRoles[productForLine(b).role].length - componentRoles[productForLine(a).role].length);
      for (const role of priorities) {
        const target = recommendations.find((product) => product.role === role);
        if (!target?.available || !target.variantId || cart.items.some((line) => isSameProduct(line, target))) continue;
        const remaining = [...componentRoles[role]];
        const lines = [];
        const quantities = {};
        for (const line of eligible) {
          const parts = componentRoles[productForLine(line).role];
          let quantity = 0;
          // Never split a bundle into components. Only replace whole units.
          while (quantity < Number(line.quantity)) {
            const next = [...remaining];
            if (!parts.every((part) => { const index = next.indexOf(part); if (index < 0) return false; next.splice(index, 1); return true; })) break;
            remaining.splice(0, remaining.length, ...next);
            quantity += 1;
          }
          if (quantity) { lines.push(line); quantities[line.key] = quantity; }
        }
        if (!lines.length) continue;
        const untouched = cart.items.filter((line) => Number(line.quantity) > (quantities[line.key] || 0))
          .flatMap((line) => componentRoles[productForLine(line)?.role] || []);
        if (remaining.some((part) => untouched.includes(part))) continue;
        const replacedPrice = lines.reduce((sum, line) => sum + Math.round(Number(line.final_line_price) * quantities[line.key] / Number(line.quantity)), 0);
        // Existing discounts must not make a same-content swap more expensive.
        if (!remaining.length && target.price >= replacedPrice) continue;
        const originalPrice = lines.reduce((sum, line) => sum + Math.round(Number(line.original_line_price ?? line.final_line_price) * quantities[line.key] / Number(line.quantity)), 0);
        const sameProductPack = componentRoles[role].length === 2 && new Set(componentRoles[role]).size === 1;
        // A Wash Day Duo is upgraded to the Wash + Clay Trio first (Lucas, 13 Oct 2026).
        const preferred = role === 'wash-clay-trio' && lines.some((line) => productForLine(line).role === 'washday');
        plans.push({target, lines, quantities, added: remaining, sameProductPack, preferred, difference: target.price - originalPrice,
          repeats: remaining.filter((part) => cartComponents(cart).includes(part)).length,
          covered: componentRoles[role].length - remaining.length, rank: priorities.indexOf(role)});
      }
      plans.sort((a, b) => Number(Boolean(a.added.length)) - Number(Boolean(b.added.length))
        || Number(b.preferred) - Number(a.preferred)
        || Number(a.sameProductPack) - Number(b.sameProductPack) || a.repeats - b.repeats || a.added.length - b.added.length || b.covered - a.covered || a.rank - b.rank);
      return plans;
    };
    const chooseUpgrades = (cart) => {
      const plans = upgradePlans(cart);
      const selected = [];
      const best = plans[0];
      for (const plan of plans) {
        if (selected.length === 2) break;
        if (plan !== best && !best.added.length) {
          const preservesConsolidation = best.lines.every((line) => (plan.quantities[line.key] || 0) >= best.quantities[line.key]);
          if (!preservesConsolidation || !plan.added.length) continue;
        }
        const additions = [...plan.added].sort().join('|');
        if (selected.some((other) => [...other.added].sort().join('|') === additions)) continue;
        selected.push(plan);
      }
      return selected;
    };
    const chooseAddOns = (cart, upgrades = chooseUpgrades(cart)) => {
      if (!cart.items.length) return [];
      const covered = new Set([...cartComponents(cart), ...upgrades.flatMap((upgrade) => upgrade.added)]);
      const suggestions = [];
      for (const product of rankedRecommendations()) {
        const parts = componentRoles[product.role];
        if (!product.available || !product.variantId || !parts || parts.some((part) => covered.has(part))) continue;
        suggestions.push(product);
        parts.forEach((part) => covered.add(part));
        if (suggestions.length === 2) break;
      }
      return suggestions;
    };
    let upgradeCopy = {};
    try { upgradeCopy = JSON.parse(drawer.querySelector('[data-cart-upgrade-copy]')?.textContent || '{}'); } catch (error) { upgradeCopy = {}; }
    // Translated strings arrive HTML-escaped (an apostrophe as &#39;). Decode once here; everything is escaped again on output.
    const decodeCopy = document.createElement('textarea');
    Object.keys(upgradeCopy).forEach((key) => { decodeCopy.innerHTML = upgradeCopy[key]; upgradeCopy[key] = decodeCopy.value; });
    const fillCopy = (text, values) => Object.entries(values).reduce((result, [token, value]) => result.split(token).join(value), text || '');
    const roleProduct = (role) => recommendations.find((product) => product.role === role);
    const joinTitles = (roles) => roles.map((role) => roleProduct(role)?.title).filter(Boolean).join(' + ');
    // What a bundle holds: one row per product with its studio photo and its name and size, as on the product page.
    const contentsList = (product) => {
      const parts = componentRoles[product.role] || [];
      if (parts.length < 2) return [];
      return [...new Set(parts)].map((role) => {
        const item = roleProduct(role);
        const name = upgradeCopy[`name_${role}`] || item?.title;
        const count = parts.filter((part) => part === role).length;
        return name ? {text: count > 1 ? `${count} \u00d7 ${name}` : name, image: item?.image || ''} : null;
      }).filter(Boolean);
    };
    const upgradeIcons = {
      shield: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9.6"/><path d="m7.9 12.4 2.9 2.9 5.4-5.6"/></svg>'
    };
    // One featured upgrade, shown as a sum in pictures: what is already in the cart plus what gets added.
    // Every figure comes from the cart lines and the shared price data. The saving shown is the one this
    // upgrade adds (the added products at their own prices, less the extra cost), and it is left out when it is not a saving.
    const renderFeaturedUpgrade = (upgrade) => {
      const target = upgrade.target;
      const replaced = upgrade.lines.reduce((sum, line) => sum + Math.round(Number(line.final_line_price) * upgrade.quantities[line.key] / Number(line.quantity)), 0);
      const extra = Number(target.price) - replaced;
      const separately = upgrade.added.reduce((sum, role) => sum + (Number(roleProduct(role)?.price) || 0), 0);
      const saving = upgrade.added.length ? separately - extra : -extra;

      // Tiles: what is already in the cart, then what gets added. A bundle already in the cart is one tile with
      // its own photo and name, not split into its products, so an upgrade never shows more tiles than it needs
      // (a Wash + Powder Trio upgrading to the Complete Hair System showed four tiles and ran off a phone screen).
      const tiles = [];
      upgrade.lines.forEach((line) => {
        const product = productForLine(line);
        const lineParts = componentRoles[product?.role] || [];
        for (let unit = 0; unit < (upgrade.quantities[line.key] || 0); unit += 1) {
          if (lineParts.length > 1) tiles.push({item: product, isNew: false});
          else lineParts.forEach((role) => tiles.push({item: roleProduct(role) || product, isNew: false}));
        }
      });
      upgrade.added.forEach((role) => tiles.push({item: roleProduct(role), isNew: true}));
      const sum = tiles.map((tile, index) => {
        const item = tile.item;
        const image = item?.image ? `<img src="${escapeHtml(responsiveAssetUrl(item.image, 168))}" alt="" width="72" height="72" loading="lazy" decoding="async">` : '';
        return `${index ? '<span class="cart-upgrade__plus" aria-hidden="true">+</span>' : ''}<span class="cart-upgrade__item${tile.isNew ? ' cart-upgrade__item--new' : ''}"><span class="cart-upgrade__thumb">${image}</span><span class="cart-upgrade__name">${escapeHtml(item?.title || '')}</span><small>${escapeHtml(tile.isNew ? upgradeCopy.added : upgradeCopy.inCart)}</small></span>`;
      }).join('');

      const addedNames = upgrade.sameProductPack
        ? fillCopy(upgradeCopy.second, {__P__: roleProduct(upgrade.added[0])?.title || ''})
        : joinTitles(upgrade.added).split(' + ').join(' and ');
      const heading = upgrade.added.length
        ? fillCopy(upgrade.sameProductPack ? upgradeCopy.addSecondHeading : upgradeCopy.addHeading, {__I__: addedNames})
        : extra < 0 ? fillCopy(upgradeCopy.sameHeading, {__A__: money(-extra)}) : fillCopy(drawer.dataset.upgradeTo, {__PRODUCT__: target.title});
      const percent = upgrade.added.length && saving > 0 && separately > 0 ? Math.round(saving * 100 / separately) : 0;
      const price = upgrade.added.length && extra > 0
        ? `<p class="cart-upgrade__price"><strong>${money(extra)}</strong>${saving > 0 ? `<s>${money(separately)}</s>` : ''}${percent > 0 ? `<span class="cart-upgrade__off">${saveIcon}${escapeHtml(fillCopy(upgradeCopy.percent, {__N__: String(percent)}))}</span>` : ''}</p>`
        : '';
      const tag = saving > 0 ? `<span class="cart-upgrade__tag">${escapeHtml(fillCopy(upgradeCopy.tag, {__A__: money(saving)}))}</span>` : '';
      // "Upgrade and Save" only when the upgrade really saves money.
      const buttonText = extra > 0 ? (saving > 0 ? upgradeCopy.button : drawer.dataset.upgradeBundleLabel)
        : extra < 0 ? fillCopy(upgradeCopy.switch, {__A__: money(-extra)}) : drawer.dataset.upgradeBundleLabel;
      const groupLabel = `${target.title}: ${tiles.map((tile) => `${tile.item?.title || ''} (${tile.isNew ? upgradeCopy.added : upgradeCopy.inCart})`).join(', ')}`;
      return `
        <section class="cart-upgrade${tag ? ' cart-upgrade--tagged' : ''}" aria-label="${escapeHtml(drawer.dataset.upsellLabel)}">
          ${tag}
          <h3 class="cart-upgrade__title">${escapeHtml(heading)}</h3>
          <div class="cart-upgrade__sum cart-upgrade__sum--${tiles.length}" role="group" aria-label="${escapeHtml(groupLabel)}">${sum}</div>
          ${price}
          <button class="cart-upgrade__button" type="button" data-cart-bundle-upgrade="${target.variantId}" data-cart-upgrade-lines="${escapeHtml(upgrade.lines.map((line) => line.key).join('|'))}">${escapeHtml(buttonText)}</button>
          ${upgradeCopy.guarantee ? `<p class="cart-upgrade__guarantee">${upgradeIcons.shield}<span>${escapeHtml(upgradeCopy.guarantee)}</span></p>` : ''}
        </section>`;
    };
    // Any further upgrade and the add-ons sit below as quiet rows.
    const renderQuietCards = (cart, upgrades) => [
      ...upgrades.slice(1).map((upgrade) => renderProductCard(upgrade.target, {
        quiet: true, compact: true, showPriceDetails: true, hideButtonPrice: true, contents: contentsList(upgrade.target),
        buttonLabel: upgradeCopy.quiet || drawer.dataset.upgradeBundleLabel, upgradeLines: upgrade.lines.map((line) => line.key)
      })),
      ...chooseAddOns(cart, upgrades).map((product) => renderProductCard(product, {
        quiet: true, compact: true, showPriceDetails: true, hideButtonPrice: true, contents: contentsList(product),
        buttonLabel: upgradeCopy.addShort || drawer.dataset.addLabel
      }))
    ].join('');

    const renderCart = (cart) => {
      if (cart.currency) drawer.dataset.currency = cart.currency;
      offerCart = (cart.items || []).map((line) => `${line.quantity} x ${line.product_title}`).join(', ').slice(0, 100);
      updateHeaderCount(cart.item_count);
      setStatus('');

      if (!cart.item_count) {
        const emptyProducts = ['complete-hair-system', 'washday', 'hair-clay', 'single']
          .map((role) => recommendations.find((product) => product.role === role && product.available && product.variantId))
          .filter(Boolean);
        // "Best Value" goes on the suggestion with the biggest saving, as on the product page, when more than one saves.
        const savingPercent = (product) => Number(String(product.saveLabel || '').replace(/[^0-9]/g, '')) || 0;
        const savers = emptyProducts.filter((product) => savingPercent(product) > 0);
        const bestValue = savers.length > 1 ? savers.reduce((best, product) => savingPercent(product) > savingPercent(best) ? product : best) : null;
        const cards = emptyProducts
          .map((product) => `
            <article class="cart-drawer__empty-card${product.saveLabel ? ' cart-drawer__empty-card--saving' : ''}${product === bestValue ? ' cart-drawer__empty-card--best' : ''}">
              ${product.saveLabel ? `<span class="cart-drawer__empty-card-save">${saveIcon}${escapeHtml(`${savingPercent(product)}% OFF`)}</span>` : ''}
              ${product === bestValue ? `<span class="cart-drawer__product-badge cart-drawer__empty-card-best">${escapeHtml(drawer.dataset.bestValueLabel || 'Best Value')}</span>` : ''}
              <a class="cart-drawer__empty-card-media" href="${escapeHtml(product.url)}"><img src="${escapeHtml(responsiveAssetUrl(product.image, 480))}" alt="${escapeHtml(product.title)}" width="480" height="480" loading="lazy"></a>
              <h4><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h4>
              <p class="cart-drawer__empty-card-note">${escapeHtml(({ 'complete-hair-system': 'Cleanse, condition & matte styling', washday: 'Cleanse, soften & detangle', 'hair-clay': 'Matte finish & strong hold', single: 'Instant volume & texture' })[product.role] || '')}</p>
              <p class="cart-drawer__empty-card-price"><strong>${money(product.price)}</strong>${product.comparePrice > product.price ? `<s>${money(product.comparePrice)}</s>` : ''}</p>
              <button class="cart-drawer__product-add" type="button" data-cart-recommendation-add="${product.variantId}">${escapeHtml(drawer.dataset.addLabel || 'Add To Cart')}</button>
            </article>`)
          .join('');
        const emptyRecommendationsTitle = 'Our Most Popular Products';

        body.innerHTML = `
          <div class="cart-drawer__empty">
            <h3>${escapeHtml(drawer.dataset.emptyTitle)}</h3>
            <a class="cart-drawer__continue" href="/collections/shop-all"><span>${escapeHtml(emptyButtonLabel)}</span></a>
          </div>
          ${cards ? `
            <section class="cart-drawer__recommendations cart-drawer__recommendations--popular" aria-label="${escapeHtml(emptyRecommendationsTitle)}">
              <h3>${escapeHtml(emptyRecommendationsTitle)}</h3>
              <div class="cart-drawer__empty-grid">
                ${cards}
              </div>
            </section>
          ` : ''}
        `;
        if (footerRecommendation) {
          footerRecommendation.innerHTML = '';
          footerRecommendation.hidden = true;
        }
        footer.hidden = true;
        return;
      }

      body.innerHTML = `
        <div class="cart-drawer__lines">
          ${cart.items.map(renderLine).join('')}
        </div>
      `;

      if (footerRecommendation) {
        const upgrades = chooseUpgrades(cart);
        const featuredUpgrade = upgrades.length ? renderFeaturedUpgrade(upgrades[0]) : '';
        const quietCards = renderQuietCards(cart, upgrades);
        const hasMerchandising = Boolean(featuredUpgrade || quietCards);

        footerRecommendation.innerHTML = hasMerchandising ? `
          ${featuredUpgrade}
          ${quietCards ? `
            <section class="cart-drawer__recommendations cart-drawer__merchandising" aria-label="${escapeHtml(drawer.dataset.recommendationsTitle)}">
              <h3>${escapeHtml(drawer.dataset.recommendationsTitle)}</h3>
              <div class="cart-drawer__recommendation-grid cart-drawer__recommendation-grid--quiet">${quietCards}</div>
            </section>` : ''}
        ` : '';
        footerRecommendation.hidden = !hasMerchandising;
      }

      renderDiscountPricing(cart);
      if (estimatedTotal) estimatedTotal.textContent = money(cart.total_price);
      if (checkout) checkout.innerHTML = `${lockIcon}<span>${escapeHtml(checkoutLabel)}</span>`;
      footer.hidden = false;
    };

    const fetchCart = async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };

    const refreshRecommendations = async (currency) => {
      // Render once in the current market so stock, variant IDs and bundle values agree.
      try {
        const response = await fetch(`${root}?section_id=cart-recommendations`, { cache: 'no-store' });
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = document.querySelector('[data-cart-recommendations]');
        const sourceCurrency = document.querySelector('[data-cart-recommendation-currency]')?.dataset.cartRecommendationCurrency;
        if (!source || sourceCurrency !== currency) return;
        const products = JSON.parse(source.textContent);
        if (!Array.isArray(products)) return;
        recommendations = products.filter(Boolean);
        recommendationCurrency = sourceCurrency;
      } catch (error) {
        // The initial server-rendered catalogue remains usable if refresh is unavailable.
      }
    };

    const addVariant = async (variantId, quantity = 1) => {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => null);
        throw new Error(error?.description || drawer.dataset.errorText);
      }

      return response.json();
    };

    const submitCartUpdateFallback = (updates) => {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = `${root}cart/update`;

      Object.entries(updates).forEach(([id, quantity]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `updates[${id}]`;
        input.value = String(quantity);
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    };

    const upgradeToBundle = async (lineKeys, bundleVariantId) => {
      const currentCart = await fetchCart();
      const currentUpgrade = chooseUpgrades(currentCart).find((upgrade) => String(upgrade.target.variantId) === String(bundleVariantId));
      if (!currentUpgrade || String(currentUpgrade.target.variantId) !== String(bundleVariantId) || currentUpgrade.lines.length !== lineKeys.length || !currentUpgrade.lines.every((line) => lineKeys.includes(line.key))) {
        renderCart(currentCart);
        return currentCart;
      }
      const updates = { [bundleVariantId]: 1 };
      lineKeys.filter(Boolean).forEach((lineKey) => {
        const line = currentUpgrade.lines.find((item) => item.key === lineKey);
        updates[lineKey] = Number(line.quantity) - currentUpgrade.quantities[lineKey];
      });

      if (!Object.keys(updates).length) return fetchCart();

      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type') || '';
        if (response.status === 429 || contentType.includes('text/html')) {
          submitCartUpdateFallback(updates);
          return null;
        }

        const error = await response.json().catch(() => null);
        throw new Error(error?.description || drawer.dataset.errorText);
      }

      return response.json();
    };

    const refreshCart = async () => {
      setLoading(true);
      try {
        const cart = await fetchCart();
        await refreshRecommendations(cart.currency || drawer.dataset.currency);
        renderCart(cart);
      } catch (error) {
        setStatus(drawer.dataset.errorText || 'Cart could not be updated.');
      } finally {
        setLoading(false);
        if (status && status.textContent === (drawer.dataset.loadingText || 'Loading cart.')) setStatus('');
      }
    };

    // Offer tracking: counts which cart offers are shown and which are tapped, so their order can follow real numbers.
    // Sends the offer, its price and what is in the cart to Google Analytics and Shopify's analytics. Nothing about the shopper.
    let offerCart = '';
    const offersSeen = new Set();
    const offerDetails = (button) => {
      const variantId = button.dataset.cartBundleUpgrade || button.dataset.cartRecommendationAdd;
      const product = recommendations.find((item) => String(item.variantId) === String(variantId));
      const type = button.closest('.cart-upgrade') ? 'featured_upgrade'
        : button.dataset.cartBundleUpgrade ? 'upgrade_row'
        : button.closest('.cart-drawer__empty-card') ? 'empty_cart' : 'add_on_row';
      return {offer_type: type, offer_product: product?.title || String(variantId), offer_price: product ? Number(product.price) / 100 : 0, cart_contents: offerCart || 'empty'};
    };
    const trackOffer = (name, button) => {
      try {
        const details = offerDetails(button);
        if (typeof window.gtag === 'function') window.gtag('event', name, details);
        window.Shopify?.analytics?.publish?.(name, details);
      } catch (error) { /* Tracking must never break the cart. */ }
    };
    // A view counts once per offer and cart on each page, and only while the drawer is open.
    const trackOfferViews = () => {
      if (!drawer.classList.contains('is-open')) return;
      drawer.querySelectorAll('[data-cart-bundle-upgrade], [data-cart-recommendation-add]').forEach((button) => {
        const details = offerDetails(button);
        const key = `${details.offer_type}|${details.offer_product}|${details.cart_contents}`;
        if (offersSeen.has(key)) return;
        offersSeen.add(key);
        trackOffer('cart_offer_view', button);
      });
    };
    new MutationObserver(trackOfferViews).observe(drawer, {childList: true, subtree: true});

    const openDrawer = async ({ refresh = true } = {}) => {
      previousFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      if (refresh) await refreshCart();
      trackOfferViews();
      panel?.focus({ preventScroll: true });
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
    };

    const changeLine = async (key, quantity, focusStep) => {
      if (lineChangeController) lineChangeController.abort();
      const controller = new AbortController();
      lineChangeController = controller;
      setLoading(true);
      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity }),
          signal: controller.signal
        });

        if (!response.ok) throw new Error('Cart line change failed');
        renderCart(await response.json());
        // Rendering replaces the line, so return focus to the control that was used.
        if (focusStep) {
          const line = [...drawer.querySelectorAll('[data-cart-line]')].find((item) => item.dataset.cartLine === key);
          const control = line?.querySelector(`[data-cart-line-step="${focusStep}"]`);
          (control || panel)?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        setStatus(drawer.dataset.errorText || 'Cart could not be updated.');
      } finally {
        if (lineChangeController === controller) {
          lineChangeController = null;
          setLoading(false);
        }
      }
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-cart-toggle]');
      if (toggle && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const step = event.target.closest('[data-cart-line-step]');
      if (step) {
        const line = step.closest('[data-cart-line]');
        const input = line?.querySelector('input');
        if (!line || !input) return;

        const nextQuantity = Math.max(0, Number(input.value || 0) + Number(step.dataset.cartLineStep || 0));
        changeLine(line.dataset.cartLine, nextQuantity, step.dataset.cartLineStep);
        return;
      }

      const remove = event.target.closest('[data-cart-line-remove]');
      if (remove) {
        const line = remove.closest('[data-cart-line]');
        if (line) changeLine(line.dataset.cartLine, 0, "remove");
        return;
      }

      const contentsToggle = event.target.closest('[data-cart-contents-toggle]');
      if (contentsToggle) {
        const list = contentsToggle.closest('.cart-drawer__product-card')?.querySelector('.cart-drawer__contents-list');
        if (list) {
          list.hidden = !list.hidden;
          contentsToggle.setAttribute('aria-expanded', String(!list.hidden));
        }
        return;
      }

      const upgrade = event.target.closest('[data-cart-bundle-upgrade]');
      if (upgrade) {
        event.preventDefault();
        trackOffer('cart_offer_tap', upgrade);
        upgrade.disabled = true;
        setLoading(true);

        const upgradeLines = (upgrade.dataset.cartUpgradeLines || '').split('|').filter(Boolean);
        upgradeToBundle(upgradeLines, upgrade.dataset.cartBundleUpgrade)
          .then((cart) => {
            if (cart) renderCart(cart);
          })
          .catch((error) => setStatus(error.message || drawer.dataset.errorText || 'Cart could not be updated.'))
          .finally(() => {
            upgrade.disabled = false;
            setLoading(false);
          });
        return;
      }

      const recommendation = event.target.closest('[data-cart-recommendation-add]');
      if (recommendation) {
        event.preventDefault();
        if (addPending) return;
        trackOffer('cart_offer_tap', recommendation);
        addPending = true;
        recommendation.disabled = true;
        setLoading(true);

        addVariant(recommendation.dataset.cartRecommendationAdd)
          .then(async () => refreshCart())
          .catch(async (error) => {
            await refreshCart();
            setStatus(error.message || drawer.dataset.errorText || 'Cart could not be updated.');
          })
          .finally(() => {
            addPending = false;
            recommendation.disabled = false;
            setLoading(false);
          });
        return;
      }

    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('.cart-drawer__quantity input');
      if (!input) return;

      const line = input.closest('[data-cart-line]');
      if (line) changeLine(line.dataset.cartLine, Math.max(0, Number(input.value || 0)));
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;

      event.preventDefault();
      if (addPending) return;
      addPending = true;
      const submitter = event.submitter;
      if (submitter) { submitter.disabled = true; submitter.setAttribute('aria-busy', 'true'); }
      setLoading(true);

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) {
          const error = await response.json().catch(() => null);
          throw new Error(error?.description || drawer.dataset.errorText);
        }

        await openDrawer({ refresh: true });
      } catch (error) {
        await openDrawer({ refresh: true });
        setStatus(error.message || drawer.dataset.errorText || 'Cart could not be updated.');
      } finally {
        addPending = false;
        setLoading(false);
        if (submitter) { submitter.disabled = submitter.getAttribute('aria-disabled') === 'true'; submitter.removeAttribute('aria-busy'); }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab' || !panel) return;
      const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
